import {Component, OnInit} from "@angular/core";
import {SelectItem} from 'primeng/primeng';

@Component({
    selector: 'roles-users',
    template: require('./role.component.pug'),
    styles: [require('./role.component.css')]
})
export class RoleComponent implements OnInit {

    emails: SelectItem[] = [];
    selectedEmail: string;

    roles: SelectItem[] = [];
    selectedRol: string;

    selectedValue: string[] = ['val1','val2'];

    perms: any = {
        'CREATE_CAT': false,
        'CREATE_POST': false,
        'CREATE_TAG': false,
        'EDIT_CAT': false,
        'EDIT_CAT_OTHER': false,
        'EDIT_POST': false,
        'EDIT_POST_OTHER': false,
        'EDIT_TAG': false,
        'EDIT_TAG_OTHER': false,
        'DEL_CAT': false,
        'DEL_CAT_OTHER': false,
        'DEL_POST': false,
        'DEL_POST_OTHER': false,
        'DEL_TAG': false,
        'DEL_TAG_OTHER': false,
        'PUB_POST': false,        
        'PUB_POST_OTHER': false,
        'CREATE_PAGE': false,
        'EDIT_PAGE': false,
        'EDIT_PAGE_OTHER': false,
        'DEL_PAGE': false,
        'DEL_PAGE_OTHER': false,
        'CREATE_METADATA': false,
        'EDIT_METADATA': false,
        'EDIT_METADATA_OTHER': false,
        'DEL_METADATA': false,
        'DEL_METADATA_OTHER': false,
        'CREATE_SITE': false,
        'EDIT_ROL': false,
        'DEL_SITE': false
    }



    siteadmin: any = [
      'CREATE_CAT',
      'CREATE_POST',
      'CREATE_TAG',
      'EDIT_CAT',
      'EDIT_CAT_OTHER',
      'EDIT_POST',
      'EDIT_POST_OTHER',
      'EDIT_TAG',
      'EDIT_TAG_OTHER',
      'DEL_CAT',
      'DEL_CAT_OTHER',
      'DEL_POST',
      'DEL_POST_OTHER',
      'DEL_TAG',
      'DEL_TAG_OTHER',
      'PUB_POST',
      'PUB_POST_OTHER',
      'CREATE_PAGE',
      'EDIT_PAGE',
      'EDIT_PAGE_OTHER',
      'DEL_PAGE',
      'DEL_PAGE_OTHER',
      'CREATE_METADATA',
      'EDIT_METADATA',
      'EDIT_METADATA_OTHER',
      'DEL_METADATA',
      'DEL_METADATA_OTHER',
      'EDIT_ROL',
    ];  
        
    

    editor: any = [  
      'CREATE_CAT',
      'CREATE_POST', 
      'CREATE_TAG',
      'EDIT_CAT',
      'EDIT_CAT_OTHER',
      'EDIT_POST',
      'EDIT_POST_OTHER',
      'EDIT_TAG',
      'EDIT_TAG_OTHER',
      'DEL_CAT',
      'DEL_CAT_OTHER',
      'DEL_POST',
      'DEL_POST_OTHER',
      'DEL_TAG',
      'DEL_TAG_OTHER',
      'PUB_POST',
      'PUB_POST_OTHER',
      'EDIT_PAGE',
      'EDIT_PAGE_OTHER',
      'EDIT_METADATA',
      'EDIT_METADATA_OTHER',
      'DEL_METADATA_OTHER',
    ];

    autor:  any = [
      'CREATE_POST',
      'EDIT_POST',
      'DEL_POST',
      'DEL_TAG',
      'PUB_POST',
    ];

    renombrarDialog: boolean = false;

    constructor() {
        console.log('[RolesUsersComponent][constructor]');
        this.emails = [{label: 'Elige e-mail', value: null},
            {label: 'brenda', value: 'oliveros'}
            ];

        this.roles = [{label: 'Selecciona el rol (perfil)', value: null},
            {label: 'Site Admin', value: 'siteadmin'},
            {label: 'Editor', value: 'editor'},
            {label: 'Autor', value: 'autor'},
            {label: 'Analista', value: 'analista'}
            ];

    }

    async ngOnInit() {

	}

	addRol() {

	}
    invitatedSend() {

    }
    showrenameDlg() {
        this.renombrarDialog = true;
    }

    onChangeSelectRole(event:any) {
        console.log(event.value);
        for (let role of Object.keys(this.perms)) {
            this.perms[role] = false;
        }
        if ( event.value == "autor" ) {
            
            for (let role of this.autor) {
                this.perms[role] = true;
                }

            };

        if ( event.value == "editor" ) {
            for (let role of this.editor) {
                this.perms[role] = true;
                }

            };

        if ( event.value == "siteadmin" ) {
            for (let role of this.siteadmin) {
                this.perms[role] = true;
                }
            };



    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/roles/role.component.ts